import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

const preSave = (payload) => {
  if (payload.admins) {
    payload.admins = payload?.admins?.map((i) => ({ _id: i._id, account: { _id: i?.account?._id || i.accountId } }));
  }
  return payload;
};

export const organizationDepartmentProcess = createCrudVuexModule({
  namespaced: true,
  path: "/department-process",
  options: { localizedFields: ["name", "description", "note"] },
  preSave,
  actions: {
    async addFromLibrary({ commit }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.post("/department-process/add-from-library", payload);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },

    async markAsComplete({ getters, commit, dispatch }, id) {
      const response = await rest.put(`/department-process/complete`, { id });
      return response;
    },

    async updateAdmins({ getters, commit, dispatch }, payload) {
      commit("isUpdating", true);
      try {
        payload = preSave(payload);
        const response = await rest.put(`/department-process/admins`, payload);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async updateNote({ getters, commit, dispatch }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.put(`/department-process/note`, payload);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async save({ dispatch }, { payload, changeInAllHierarchy }) {
      if (preSave) {
        payload = await preSave(payload);
      }

      if (payload._id) {
        return dispatch("update", { payload, changeInAllHierarchy });
      } else {
        return dispatch("create", payload);
      }
    },

    async create({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);
        payload = await dispatch("preparePayload", {
          editedEntity: getters.editedEntity,
          form: payload,
        });

        const response = await rest.post(`/department-process`, { item: payload });
        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },

    async update({ getters, commit, dispatch }, { payload, changeInAllHierarchy }) {
      try {
        commit("isUpdating", true);
        payload = await dispatch("preparePayload", {
          editedEntity: getters.editedEntity,
          form: payload,
        });

        const response = await rest.put(`/department-process`, { item: payload, changeInAllHierarchy });

        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
  },
});
